import uploadAssets from "./uploadAssets";

const uploadImages = crm => async info => {
	info.extensionsToExclude = ["pdf"];
	return await uploadAssets(crm)({ ...info });
};

export default uploadImages;
